// src/components/ContactPage.js
import React, { useEffect, useState, useContext } from 'react';
import './ContactPage.css';
import { LanguageContext } from '../translations/LanguageContext'; // Ensure the path is correct

function ContactPage() {
  const { language, translations } = useContext(LanguageContext);
  const contactText = translations[language].contactPage;

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null },
  });

  const [animate, setAnimate] = useState(false);

  // Start the animation on page load
  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimate(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate form fields
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setStatus({
        ...status,
        info: { error: true, msg: contactText.errorEmpty },
      });
      return;
    }

    if (!validateEmail(formData.email)) {
      setStatus({
        ...status,
        info: { error: true, msg: contactText.errorEmail },
      });
      return;
    }

    setStatus({ ...status, submitting: true });

    // Define the recipient email address
    const recipientEmail = 'agianniproject@gmail.com'; 

    // Construct the mailto link
    const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(
      formData.subject
    )}&body=${encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
    )}`;

    // Open the mailto link in the user's default mail client
    window.location.href = mailtoLink;

    // Update the status to reflect submission
    setStatus({
      submitted: true,
      submitting: false,
      info: { error: false, msg: contactText.successMsg },
    });

    // Reset the form
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: '',
    });
  };

  return (
    <section className="contact-page">
      <div className="container">
        <div className="icon-container">
          <svg
            className={`mail-icon ${animate ? 'animate' : ''}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
          >
            {/* Envelope Top */}
            <path d="M10,30 L50,60 L90,30" className="mail-line" />
            {/* Envelope Base */}
            <rect x="10" y="30" width="80" height="40" className="mail-envelope" />
            {/* Missing Left Line */}
            <line x1="10" y1="30" x2="10" y2="70" className="mail-left-line" />
          </svg>
          <h1>{contactText.title}</h1>
        </div>
        <p>{contactText.subtitle}</p>

        <form className="contact-form" onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="name">
              {contactText.nameLabel}
              <span className="required">{contactText.required}</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder={contactText.namePlaceholder}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">
              {contactText.emailLabel}
              <span className="required">{contactText.required}</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder={contactText.emailPlaceholder}
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">
              {contactText.subjectLabel}
              <span className="required">{contactText.required}</span>
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              placeholder={contactText.subjectPlaceholder}
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">
              {contactText.messageLabel}
              <span className="required">{contactText.required}</span>
            </label>
            <textarea
              id="message"
              name="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder={contactText.messagePlaceholder}
            ></textarea>
          </div>

          {status.info.error && <div className="error-message">{status.info.msg}</div>}
          {status.info.msg && !status.info.error && <div className="success-message">{status.info.msg}</div>}

          <button type="submit" disabled={status.submitting}>
            {status.submitting ? contactText.sendingButton : contactText.sendButton}
          </button>
        </form>
      </div>
    </section>
  );
}

export default ContactPage;
